import { render, staticRenderFns } from "./DeleteBriefcaseFolderDialog.vue?vue&type=template&id=4a63e1bf&scoped=true"
import script from "./DeleteBriefcaseFolderDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteBriefcaseFolderDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a63e1bf",
  null
  
)

export default component.exports